var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "upload-cover-component",
        { complete: _vm.image.status === "COMPLETE" }
      ]
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.image.status === "COMPLETE" || _vm._initImageUrl,
              expression: "image.status === 'COMPLETE' || _initImageUrl"
            }
          ],
          staticClass: "displaying-image"
        },
        [
          _vm.image.croppedImageUrl
            ? _c("img", {
                staticClass: "cropped-image",
                attrs: { src: _vm.image.croppedImageUrl, alt: "Cropped Image" }
              })
            : _vm._initImageUrl
            ? _c("img", {
                staticClass: "cropped-image",
                attrs: { src: _vm._initImageUrl, alt: "Cropped Image" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "change-btn-wrap" }, [
            _c(
              "button",
              {
                staticClass: "round-btn-small",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.changeImage()
                  }
                }
              },
              [_vm._v("Change Image")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.image.status !== "COMPLETE" &&
                !_vm._initImageUrl &&
                !_vm.showCropperModal,
              expression:
                "image.status !== 'COMPLETE' && !_initImageUrl && !showCropperModal"
            }
          ],
          class: [
            "upload-dropzone",
            _vm.in_progress,
            { dragover: _vm.dragover }
          ],
          on: {
            click: _vm.onClick,
            drop: function($event) {
              $event.preventDefault()
              return _vm.onDrop($event)
            },
            dragover: function($event) {
              $event.preventDefault()
              _vm.dragover = true
            },
            dragleave: function($event) {
              $event.preventDefault()
              _vm.dragover = false
            }
          }
        },
        [
          _c("input", {
            ref: "fileInput",
            attrs: { type: "file", accept: ".jpeg, .jpg, .png" },
            on: {
              change: function($event) {
                return _vm.selectionProcessing($event)
              }
            }
          }),
          _vm._v(" "),
          Object.keys(_vm.processing_errors).length > 0 ||
          _vm.image.status === "INITIATED"
            ? _c(
                "div",
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._l(_vm.processing_errors, function(messages, field) {
                    return Object.keys(_vm.processing_errors).length > 0
                      ? _c("div", { staticClass: "errors" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm._f("unSnakeCase")(
                                  _vm._f("capitalize")(field)
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          field === "space_limited"
                            ? _c("div", { staticClass: "space_limited_msg" }, [
                                _vm._v(
                                  "\n            The file you are trying to upload exceeds the allotted storage.\n            Please clean your "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "/my_storage",
                                      target: "_blank"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                      }
                                    }
                                  },
                                  [_vm._v("Storage")]
                                ),
                                _vm._v(
                                  " first before attempting to re-upload\n            it"
                                ),
                                !_vm.is_plus_user
                                  ? _c("span", [
                                      _vm._v(", or upgrade to "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "/subscriptions",
                                            target: "_blank"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                            }
                                          }
                                        },
                                        [_vm._v("Plus account")]
                                      ),
                                      _vm._v(".")
                                    ])
                                  : _vm._e()
                              ])
                            : _c(
                                "ul",
                                _vm._l(messages, function(message) {
                                  return _c("li", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm._f("capitalize")(message)) +
                                        "\n            "
                                    )
                                  ])
                                }),
                                0
                              )
                        ])
                      : _vm._e()
                  })
                ],
                2
              )
            : _vm.image.status === "CHECKING"
            ? _c("div", [_vm._v("Checking...")])
            : _vm.image.status === "UPLOADING"
            ? _c("div", [_vm._v(_vm._s(_vm.image.upload_percentage) + "%")])
            : ["COMPLETE"].includes(_vm.image.status)
            ? _c("div", [_vm._v("Complete")])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.showCropperModal
        ? _c("div", { staticClass: "vue2-cropper modal show" }, [
            _c("div", { staticClass: "modal-dialog" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.closeCropperModal()
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "20px" },
                        attrs: {
                          src:
                            "/assets/icon/x-20x20-white-991e6626a05b3d3d42dcef5f8bd62d5463ab13964109a59e15c2507fc2b73334.svg"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "crop-wrapper" },
                    [
                      _c("vue-cropper", {
                        ref: "cropper",
                        staticClass: "vue-cropper",
                        attrs: {
                          src: _vm.image.url,
                          alt: "Source Image",
                          viewMode: 1,
                          autoCropArea: 1,
                          aspectRatio: NaN,
                          cropBoxResizable: false,
                          cropBoxMovable: false,
                          guides: false,
                          zoomable: false,
                          zoomOnTouch: false,
                          zoomOnWheel: false,
                          dragMode: _vm.move,
                          toggleDragModeOnDblclick: false,
                          ready: _vm.onCropperReady
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "change-btn-wrap" }, [
                    _c(
                      "button",
                      {
                        staticClass: "round-btn-small",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.changeImage()
                          }
                        }
                      },
                      [_vm._v("Change Image")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "done-btn-wrap" }, [
                    _c(
                      "button",
                      {
                        staticClass: "round-btn-small",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.done()
                          }
                        }
                      },
                      [_vm._v("Done")]
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upload-image-title" }, [
      _c("span", { staticClass: "bold-text" }, [_vm._v("Upload Cover Image")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("b", [_vm._v("Cover Image")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }